const swiper = new Swiper(".related-news .swiper", {
	// Optional parameters
	loop: false,
	slidesPerView: 1,
	lazy: true,
	simulateTouch: false,

	autoplay: false,

	// If we need pagination
	pagination: false,

	// Navigation arrows
	navigation: {
	  nextEl: ".related-news .section__header .button-next",
	  prevEl: ".related-news .section__header .button-prev",
	},
});
